(function (app) {
	var parseUrlString = function (string) {
		var result = {};
		if (string) {
			$.each(string.substr(1).split('&'), function (c, q) {
				var i = q.split('='),
					name = i[0],
					value = q.replace(i[0] + '=', '');
				if (name.match(/saleID/i)) {
					$.extend(result, parceValue('saleID', 'hashedSaleID', value));
				} else if (name.match(/productID/i)) {
					$.extend(result, parceValue('productID', 'hashedProductID', value));
				} else {
					result[name] = value;
				}
			});
		}
		return result;
	};

	function isInt(n) {
		return n % 1 === 0;
	}

	function parceValue(name, hashedName, value) {
		var obj = {},
			isGuid = app.isGuid(value);
		obj[hashedName] = isGuid ? app.guidToBase64(value) : value;
		obj[name] = isGuid ? value : app.guidFromBase64(value);
		return obj;
	}

	var queryParams = parseUrlString(document.location.search);
	var hashParams = parseUrlString(document.location.hash);

	// Protection from XSS. If cid is not integer.
	if (queryParams.cid) {
		queryParams.cid = !isInt(queryParams.cid) ? 10 : queryParams.cid;
	}

	queryParams.cid = queryParams.cid || 10;
	queryParams.hashedCID = JSON.parse($('[id$="siteData"]').attr('cid') || '{}')[queryParams.cid];

	queryParams.get = function (parameterName) {
		var result;
		$.each(queryParams, function (key, value) {
			if (key.toLowerCase() === parameterName.toLowerCase()) {
				result = value;
			}
		});
		return result;
	};

	app.globalQueryParams = queryParams;
	app.hashParams = hashParams;

	app.globalParams = {
		shop: queryParams.cid ? '?cid=' + queryParams.cid : '',
		itemsList: '?' + (queryParams.cid ? 'cid=' + queryParams.cid + '&' : '') + (queryParams.hashedSaleID ? 'saleID=' + queryParams.hashedSaleID : '') + (queryParams.categoryID ? '&categoryID=' + queryParams.categoryID : '') + (queryParams.subCategoryID ? '&subCategoryID=' + queryParams.subCategoryID : ''),
		product: '?' + (queryParams.cid ? 'cid=' + queryParams.cid + '&' : '') + (queryParams.hashedSaleID ? 'saleID=' + queryParams.hashedSaleID : '') + (queryParams.categoryID ? '&categoryID=' + queryParams.categoryID : '') + (queryParams.subCategoryID ? '&subCategoryID=' + queryParams.subCategoryID : ''),
		checkout: '?' + (queryParams.cid ? 'cid=' + queryParams.cid + '&' : '') + (queryParams.hashedSaleID ? 'saleID=' + queryParams.hashedSaleID : '') + (queryParams.categoryID ? '&categoryID=' + queryParams.categoryID : '') + (queryParams.subCategoryID ? '&subCategoryID=' + queryParams.subCategoryID : '')
	};

	app.globalUrls = {
		shop: location.protocol + '//' + window.location.host + '/default.aspx' + app.globalParams.shop,
		itemsList: location.protocol + '//' + window.location.host + '/itemsList.aspx' + app.globalParams.itemsList,
		product: location.protocol + '//' + window.location.host + '/product.aspx' + app.globalParams.product,
		checkout: location.protocol + '//' + window.location.host + '/checkout.aspx' + app.globalParams.shop, // B1833, 2092 fix
		returnUrl: location.protocol + '//' + window.location.host + (queryParams['ReturnUrl'] ? decodeURIComponent(queryParams['ReturnUrl']) : '/default.aspx?cid=10')
	};
	if (hashParams.s) {
		app.globalUrls.search = app.globalUrls.shop + '#s=' + hashParams.s;
	} else if (hashParams.i) {
		app.globalUrls.search = app.globalUrls.itemsList + '#i=' + hashParams.i;
	}



})(app);